import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations'; 
//var Configuration = require('src/assets/app-config.json');
import { IProcedureCategory, IProceduresAllData, IprocedureLevels, IProcedureComponent, IProcedureCompDetails, IprocedureTypes, IProcedureParts, IprocedureSides, IprocedureOthers, IprocedureCPTCodes } from 'src/app/models/IProcedures';
import { configuration } from 'src/environments/environment';
import { IDiagnosis } from 'src/app/models/IMedicationHistoryDTO';
import { IOperatingProcedure } from 'src/app/models/IORRecord';

@Injectable({
  providedIn: 'root'
})
export class ProceduresService {
  temppage: number = 0;
  pageField = [];
  exactPageList: any;

  constructor(private http: HttpClient) { }

  getProcedureCategory(): Observable<IProcedureCategory[]> {
    return this.http.get<IProcedureCategory[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureCategory'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}`);
  }

  getProcedureLevels(P: any): Observable<IprocedureLevels[]> {
    return this.http.get<IprocedureLevels[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureLevels'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&partId=${P.partId}&&levelName=${P.levelName}&&isInsert=${P.isInsert}`);
  }

  getProcedureParts(): Observable<IProcedureParts[]> {
    return this.http.get<IProcedureParts[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureParts'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getProcedureCptCodes(): Observable<IprocedureCPTCodes[]> {
    return this.http.get<IprocedureCPTCodes[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureCptcodes'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getProcedureSides(): Observable<IprocedureSides[]> {
    return this.http.get<IprocedureSides[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureSides'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getProcedureOthers(): Observable<IprocedureOthers[]> {
    return this.http.get<IprocedureOthers[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureOthers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getProcedureTypes(): Observable<IprocedureTypes[]> {
    return this.http.get<IprocedureTypes[]>(
      `${configuration.clinicapiUrl + 'Encounter/ProcedureTypes'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getAllProcedureData(categoryId: number, pageNo: number, pageSize: number, searchTerm: string): Observable<IProceduresAllData[]> {
    return this.http.get<IProceduresAllData[]>(
      `${configuration.clinicapiUrl + 'Encounter/AllProceduresData'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&categoryId=${categoryId}&&facility=${sessionStorage.getItem("FacilityId")}&&pageNo=${pageNo}&&pageSize=${pageSize}&&searchTerm=${searchTerm}`);
  }

  addProcedureInfo(procInfo: IProcedureCompDetails): Observable<IProcedureCompDetails> {
    const posteddata = {
      inputdata: JSON.stringify(procInfo)
    }
    return this.http.post<IProcedureCompDetails>(`${configuration.clinicapiUrl + 'Encounter/PatProcedure'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getProceduresByEncId(encId: string, patId: number): Observable<IProcedureComponent[]> {
    return this.http.get<IProcedureComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/Procedure'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${encodeURIComponent(sessionStorage.getItem("FacilityId")).toString()}`);
  }

  getProceduresByEncIdSync(encId: string, patId: number, sync: boolean): Observable<IProcedureComponent[]> {
    return this.http.get<IProcedureComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/VisitNoteProcedure'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&sync=${sync}`);
  }

  getPatAllCurrentProceduresByEncId(encId: string): Observable<IProcedureComponent[]> {
    return this.http.get<IProcedureComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatCurrentProcedure'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getPatientProcByEncId(encId: string, patId: number): Observable<IProcedureComponent[]> {
    return this.http.get<IProcedureComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatProcedure'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  // DeleteSelectProcedureInfo(Id: number): Observable<number> {
  //   return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/Procedure'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
  //     headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }
  DeleteSelectProcedureInfo(DelProcDbIds: string): Observable<string> {
    return this.http.delete<string>(`${configuration.clinicapiUrl + 'Encounter/Procedure'}?id=${DelProcDbIds}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectAllPatProcedureInfo(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/PatProcedure'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getPatAllProceduresByPatId(patId: number): Observable<IProcedureComponent[]> {
    return this.http.get<IProcedureComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/AllPatProcedures'}?patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getPreviousPatProcedures(patId: number): Observable<IProcedureComponent[]> {
    return this.http.get<IProcedureComponent[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatPreviousProcedure'}?patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  getDiagnosisofCPT(cptId: number): Observable<IDiagnosis[]> {
    return this.http.get<IDiagnosis[]>
      (`${configuration.apiUrl + 'Master/getDxofCPT'}?cptId=${cptId}`);
  }

  getDiagnosisofAllProcedures(cptId: IOperatingProcedure[]): Observable<IOperatingProcedure[]> {
    return this.http.get<IOperatingProcedure[]>
      (`${configuration.clinicapiUrl + 'Encounter/getDxofAllProcedures'}?procList=${cptId}`);
  }

  //Pagination Service
  pageOnLoad() {
    if (this.temppage == 0) {
      this.pageField = [];
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    } else {
      this.temppage = 0;
      this.pageField = [];
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    }
  }
  getCountProcedures(searchTerm: string, selectedCat: number): Observable<any> {
    return this.http.get<any>(`${configuration.clinicapiUrl + 'Encounter/GetCountProcedures'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facility=${sessionStorage.getItem("FacilityId")}&&searchTerm=${searchTerm}&&selectedCat=${selectedCat}`);
  }
} 
